module.exports = __webpack_public_path__ + "img/subscriptions.f7ae9737.svg";